import { gql } from '__generated__';

const AddProjectMutation = gql(`
  mutation AddProject($input: AddProjectInput!) {
    addProject(input: $input) {
      ...ProjectFields
    }
  }
`);

export default AddProjectMutation;
